import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { uuidish } from '../../utils/uuidish.js';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
/**
 * Converts a string to an AssessmentMeasurementConfigurationReferenceType.
 */
export function toAssessmentMeasurementConfigurationReferenceType(type) {
    if (['schedule-of-activities', 'schema'].includes(type))
        return type;
    throw new IllegalArgumentError(`Invalid assessment measurement reference type [${type}]`);
}
export const assessmentMeasurementConfigurationReferenceSchema = z.object({
    assessmentMeasurementConfigurationId: uuidish,
    studyAssessmentMeasurementId: uuidish,
    type: z.enum(['schedule-of-activities', 'schema']),
    referenceId: uuidish,
    name: z.string().nullish().transform(nullishToUndefined).optional(),
});
/**
 * Converts a JSON object to an AssessmentMeasurementConfigurationReference.
 */
export function toAssessmentMeasurementConfigurationReference(reference) {
    const result = assessmentMeasurementConfigurationReferenceSchema.safeParse(reference);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementConfigurationReference object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-configuration-reference.js.map